import _ from "lodash";
import translationKeys from "../translations/keys";

export const getDeviceQuotaDisplayLayout = (devicesQuota, t) => 
    _.reduce(
        devicesQuota,
        (acc, obj, resolution) => {
            if (obj.rom) {
                acc.push(
                    <span
                        style={{ display: 'block' }}
                        key={resolution + 'rom'}
                    >
                        {obj.rom} &#10005;{' '}
                        {t(
                            translationKeys.technical
                                .resolutions[resolution]
                        )}
                        ,{' '}
                        {t(
                            translationKeys.technical
                                .recordingModes.ROM
                        )}
                    </span>
                );
            }
            if (obj.continuous) {
                acc.push(
                    <span
                        style={{ display: 'block' }}
                        key={resolution + 'continuous'}
                    >
                        {obj.continuous} &#10005;{' '}
                        {t(
                            translationKeys.technical
                                .resolutions[resolution]
                        )}
                        ,{' '}
                        {t(
                            translationKeys.technical
                                .recordingModes
                                .CONTINUOUS
                        )}
                    </span>
                );
            }
            return acc;
        },
        []
    );

export const getAddonsQuotaDisplayLayout = (addonsQuota, t) => 
    _.reduce(
        supportedAddons,
        (acc, addon) => {
            if (addonsQuota?.[addon]) {
                acc.push(
                    <span
                        style={{ display: 'block' }}
                        key={addon}
                    >
                        {addonsQuota[addon]} &#10005;{' '}
                        {t(translationKeys.technical.analytics.addons[addon])}
                    </span>
                );
            }
            return acc;
        },
        []
    );

export const supportedAddons = ["smart-motion", "lpr", "people", "ppe"];

/**
 * Storage durations in years will have one or more extra days that we don't want to show.
 * I believe this is for leap years but the extra days haven't been applied consistently,
 * e.g. 9 years has 2 extra days but 10 years only has one.
 * Hence the logic below just checks if the number of days is slightly more than a year,
 * and if so rounds down.
 * 
 * @param {number} databaseCloudDays Cloud days as assigned to account level in database.
 * @returns {number|null} Number of days to show in UI.
 */
export const getDisplayedCloudDays = databaseCloudDays => {
    if (typeof databaseCloudDays !== 'number' || databaseCloudDays < 1) {
        // Not one of our current active Videoloft cloud plans
        return null;
    }

    if (databaseCloudDays > 365 && (databaseCloudDays / 365) % 1 < 0.01) {
        return Math.floor(databaseCloudDays / 365) * 365;
    }

    return databaseCloudDays;
}

/**
 * Get highest cloud storage duration in ms from array of organisations.
 * @param {{ cloudStorageDuration: number }[]} organisations Array of organisations. Each element must be object with property `cloudStorageDuration`.
 * @returns {number} Cloud storage duration in ms.
 */
export const getMaxCloudStorageDurationFromOrganisations = organisations => {
    return organisations.reduce((acc, { cloudStorageDuration }) => Math.max(acc, cloudStorageDuration), 0);
}
